<template>
  <div>
    <div class="info-wrapper">
      <p class="description">
        Fly Talks su kratki razgovori između poslodavca i posjetitelja konferencije u opuštenoj atmosferi. Poslodavce
        smo podijelili u skupine, a ti biraš jednu ili više njih koje su ti najzanimljivije. Kad odabereš skupinu, imaš
        8 minuta sa svakim poslodavcom iz te skupine kako biste se upoznali i vidjeli koliko si međusobno odgovarate.
        Prijavi se i pokaži sve što znaš.
      </p>
      <ul class="benefits">
        <li>Pronađi posao</li>
        <li>Obogati iskustva</li>
        <li>Stekni vrijedna poznanstva</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Description',
  components: {},
  methods: {},
};
</script>

<style scoped>
.description {
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 0;
  margin-bottom: 24px;
}

.benefits {
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
  padding-left: 20px;
  margin-top: 0;
  margin-bottom: 64px;
}

@media screen and (min-width: 767px) {
  .info-wrapper {
    display: flex;
    margin-bottom: 80px;
  }

  .description {
    max-width: 500px;
    margin-bottom: 0;
    margin-right: 128px;
  }
}
</style>
